/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
import parse from 'html-react-parser';
import ReplayItem from './ReplayItem';

class CustomerItem extends Component {
  state = {
    showDetail: false,
  };
  _toggleDetail = () => {
    const { showDetail } = this.state;
    this.setState({
      showDetail: !showDetail,
    });
  };
  _onDelete = () => {
    const { idx, onItemDel } = this.props.childProps;
    ////console.log(idx)
    confirmAlert({
      title: '삭제',
      message: '삭제된 글은 복구되지 않습니다. 글을 삭제 하시겠니까? ',
      buttons: [
        {
          label: '삭제',
          onClick: () => {
            //alert(0)
            onItemDel(idx);
          },
        },

        {
          label: '취소',
          //onClick: () => alert('Click No')
        },
      ],
    });
  };
  render() {
    const { loginId, imgUrl } = this.props;
    const { showDetail } = this.state;
    const {
      userid,
      nicName,
      board_id,
      title,
      writeDay,
      categoryName,
      content,
      replay_idx,
    } = this.props.childProps;

    return (
      <Fragment>
        {board_id === 20 ? (
          <tr
            className={showDetail ? 'on' : null}
            onClick={this._toggleDetail}
            style={{ cursor: 'pointer' }}
          >
            <td>Q</td>
            <td>
              {title}{' '}
              {loginId === userid ? (
                <span
                  onClick={this._onDelete}
                  style={{ color: 'blue', position: 'absolute', right: 100 }}
                >
                  [삭제]
                </span>
              ) : null}{' '}
              {showDetail ? (
                <img src={imgUrl + '/img/mypage/up.png'} />
              ) : (
                <img src={imgUrl + '/img/mypage/down.png'} />
              )}
            </td>
          </tr>
        ) : (
          <tr
            className={showDetail ? 'on' : null}
            onClick={this._toggleDetail}
            style={{ cursor: 'pointer' }}
          >
            <td>{writeDay}</td>
            <td>{categoryName}</td>
            <td>
              {loginId === 'admin' ? (
                <span style={{ color: 'orange' }}>
                  {nicName + '(' + userid + ')'}
                </span>
              ) : null}{' '}
              {title}{' '}
              {loginId === userid || loginId === 'admin' ? (
                <span
                  onClick={this._onDelete}
                  style={{ color: 'blue', position: 'absolute', right: 100 }}
                >
                  [삭제]
                </span>
              ) : null}{' '}
              {board_id === 9 ? (
                replay_idx === 0 ? null : (
                  <span style={{ color: 'red' }}>[답변완료]</span>
                )
              ) : null}{' '}
              {showDetail ? (
                <img src={imgUrl + '/img/mypage/up.png'} />
              ) : (
                <img src={imgUrl + '/img/mypage/down.png'} />
              )}
            </td>
          </tr>
        )}

        {showDetail ? (
          board_id === 20 ? (
            <tr className="on">
              <td colSpan="2">
                <div className="on_text">
                  {parse(content)}
                  {/* parse(content.replace(/<[^>]+>/g, '')) */}
                </div>
              </td>
            </tr>
          ) : (
            <tr className="on">
              <td colSpan="3">
                <div className="on_text">
                  {parse(content)}
                  {/* parse(content.replace(/<[^>]+>/g, '')) */}
                </div>
                {board_id === 9 ? (
                  replay_idx === 0 ? null : (
                    <ReplayItem replay_idx={replay_idx} />
                  )
                ) : null}
              </td>
            </tr>
          )
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CustomerItem));
